// removed by extract-text-webpack-plugin
module.exports = {"vpVideoContainer":"vpVideoContainer___2qO6w","landscape":"landscape___sTOir","portrait":"portrait___1qYxK"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/components/VpVideoPlayer/VpVideoPlayer.module.less
// module id = 3211
// module chunks = 33